/* @generated */
// prettier-ignore
if (Intl.NumberFormat && typeof Intl.NumberFormat.__addLocaleData === 'function') {
  Intl.NumberFormat.__addLocaleData({
  "data": {
    "currencies": {
      "ADP": {
        "displayName": {
          "one": "andorransk pesetas",
          "other": "andorranske pesetas"
        },
        "narrow": "ADP",
        "symbol": "ADP"
      },
      "AED": {
        "displayName": {
          "one": "emiratarabisk dirham",
          "other": "emiratarabiske dirham"
        },
        "narrow": "AED",
        "symbol": "AED"
      },
      "AFA": {
        "displayName": {
          "one": "afghansk afghani (1927–2002)",
          "other": "afghanske afghani (1927–2002)"
        },
        "narrow": "AFA",
        "symbol": "AFA"
      },
      "AFN": {
        "displayName": {
          "one": "afghansk afghani",
          "other": "afghanske afghani"
        },
        "narrow": "؋",
        "symbol": "AFN"
      },
      "ALK": {
        "displayName": {
          "one": "albansk lek (1946–1965)",
          "other": "albanske lek (1946–1965)"
        },
        "narrow": "ALK",
        "symbol": "ALK"
      },
      "ALL": {
        "displayName": {
          "one": "albansk lek",
          "other": "albanske lek"
        },
        "narrow": "ALL",
        "symbol": "ALL"
      },
      "AMD": {
        "displayName": {
          "one": "armensk dram",
          "other": "armenske dram"
        },
        "narrow": "֏",
        "symbol": "AMD"
      },
      "ANG": {
        "displayName": {
          "one": "nederlandsk antillegylden",
          "other": "nederlandske antillegylden"
        },
        "narrow": "ANG",
        "symbol": "ANG"
      },
      "AOA": {
        "displayName": {
          "one": "angolansk kwanza",
          "other": "angolanske kwanza"
        },
        "narrow": "Kz",
        "symbol": "AOA"
      },
      "AOK": {
        "displayName": {
          "one": "angolansk kwanza (1977–1990)",
          "other": "angolanske kwanza (1977–1990)"
        },
        "narrow": "AOK",
        "symbol": "AOK"
      },
      "AON": {
        "displayName": {
          "one": "angolansk ny kwanza",
          "other": "angolanske nye kwanza (1990–2000)"
        },
        "narrow": "AON",
        "symbol": "AON"
      },
      "AOR": {
        "displayName": {
          "one": "angolansk kwanza reajustado (1995–1999)",
          "other": "angolanske omjusterte kwanza (1995–1999)"
        },
        "narrow": "AOR",
        "symbol": "AOR"
      },
      "ARA": {
        "displayName": {
          "one": "argentinsk austral",
          "other": "argentinske australer"
        },
        "narrow": "ARA",
        "symbol": "ARA"
      },
      "ARL": {
        "displayName": {
          "one": "argentinsk peso ley",
          "other": "argentinske peso ley"
        },
        "narrow": "ARL",
        "symbol": "ARL"
      },
      "ARM": {
        "displayName": {
          "one": "argentinsk pesos (1881–1970)",
          "other": "argentinske pesos (1881–1970)"
        },
        "narrow": "ARM",
        "symbol": "ARM"
      },
      "ARP": {
        "displayName": {
          "one": "argentinsk pesos (1983–1985)",
          "other": "argentinske pesos (1983–1985)"
        },
        "narrow": "ARP",
        "symbol": "ARP"
      },
      "ARS": {
        "displayName": {
          "one": "argentinsk peso",
          "other": "argentinske pesos"
        },
        "narrow": "$",
        "symbol": "ARS"
      },
      "ATS": {
        "displayName": {
          "one": "østerriksk schilling",
          "other": "østerrikske schilling"
        },
        "narrow": "ATS",
        "symbol": "ATS"
      },
      "AUD": {
        "displayName": {
          "one": "australsk dollar",
          "other": "australske dollar"
        },
        "narrow": "$",
        "symbol": "AUD"
      },
      "AWG": {
        "displayName": {
          "one": "arubisk florin",
          "other": "arubiske floriner"
        },
        "narrow": "AWG",
        "symbol": "AWG"
      },
      "AZM": {
        "displayName": {
          "one": "aserbajdsjansk manat (1993–2006)",
          "other": "aserbajdsjanske manat (1993–2006)"
        },
        "narrow": "AZM",
        "symbol": "AZM"
      },
      "AZN": {
        "displayName": {
          "one": "aserbajdsjansk manat",
          "other": "aserbajdsjanske manat"
        },
        "narrow": "₼",
        "symbol": "AZN"
      },
      "BAD": {
        "displayName": {
          "one": "bosnisk-hercegovinsk dinar (1992–1994)",
          "other": "bosnisk-hercegovinske dinarer (1992–1994)"
        },
        "narrow": "BAD",
        "symbol": "BAD"
      },
      "BAM": {
        "displayName": {
          "one": "bosnisk-hercegovinsk konvertibel mark",
          "other": "bosnisk-hercegovinske konvertible mark"
        },
        "narrow": "KM",
        "symbol": "BAM"
      },
      "BAN": {
        "displayName": {
          "one": "ny bosnisk-hercegovinsk dinar (1994–1997)",
          "other": "nye bosnisk-hercegovinske dinarer (1994–1997)"
        },
        "narrow": "BAN",
        "symbol": "BAN"
      },
      "BBD": {
        "displayName": {
          "one": "barbadisk dollar",
          "other": "barbadiske dollar"
        },
        "narrow": "$",
        "symbol": "BBD"
      },
      "BDT": {
        "displayName": {
          "one": "bangladeshisk taka",
          "other": "bangladeshiske taka"
        },
        "narrow": "৳",
        "symbol": "BDT"
      },
      "BEC": {
        "displayName": {
          "one": "belgisk franc (konvertibel)",
          "other": "belgiske franc (konvertible)"
        },
        "narrow": "BEC",
        "symbol": "BEC"
      },
      "BEF": {
        "displayName": {
          "one": "belgisk franc",
          "other": "belgiske franc"
        },
        "narrow": "BEF",
        "symbol": "BEF"
      },
      "BEL": {
        "displayName": {
          "one": "belgisk franc (finansiell)",
          "other": "belgiske franc (finansielle)"
        },
        "narrow": "BEL",
        "symbol": "BEL"
      },
      "BGL": {
        "displayName": {
          "one": "bulgarsk lev (hard)",
          "other": "bulgarske lev (hard)"
        },
        "narrow": "BGL",
        "symbol": "BGL"
      },
      "BGM": {
        "displayName": {
          "one": "bulgarsk lev (sosialist)",
          "other": "bulgarske lev (sosialist)"
        },
        "narrow": "BGM",
        "symbol": "BGM"
      },
      "BGN": {
        "displayName": {
          "one": "bulgarsk lev",
          "other": "bulgarske lev"
        },
        "narrow": "BGN",
        "symbol": "BGN"
      },
      "BGO": {
        "displayName": {
          "one": "bulgarsk lev (1879–1952)",
          "other": "bulgarske lev (1879–1952)"
        },
        "narrow": "BGO",
        "symbol": "BGO"
      },
      "BHD": {
        "displayName": {
          "one": "bahrainsk dinar",
          "other": "bahrainske dinarer"
        },
        "narrow": "BHD",
        "symbol": "BHD"
      },
      "BIF": {
        "displayName": {
          "one": "burundisk franc",
          "other": "burundiske franc"
        },
        "narrow": "BIF",
        "symbol": "BIF"
      },
      "BMD": {
        "displayName": {
          "one": "bermudisk dollar",
          "other": "bermudiske dollar"
        },
        "narrow": "$",
        "symbol": "BMD"
      },
      "BND": {
        "displayName": {
          "one": "bruneisk dollar",
          "other": "bruneiske dollar"
        },
        "narrow": "$",
        "symbol": "BND"
      },
      "BOB": {
        "displayName": {
          "one": "boliviansk boliviano",
          "other": "bolivianske boliviano"
        },
        "narrow": "Bs",
        "symbol": "BOB"
      },
      "BOL": {
        "displayName": {
          "one": "boliviansk boliviano (1863–1963)",
          "other": "bolivianske boliviano (1863–1963)"
        },
        "narrow": "BOL",
        "symbol": "BOL"
      },
      "BOP": {
        "displayName": {
          "one": "boliviansk pesos",
          "other": "bolivianske pesos"
        },
        "narrow": "BOP",
        "symbol": "BOP"
      },
      "BOV": {
        "displayName": {
          "other": "bolivianske mvdol"
        },
        "narrow": "BOV",
        "symbol": "BOV"
      },
      "BRB": {
        "displayName": {
          "one": "brasiliansk cruzeiro novo (1967–1986)",
          "other": "brasilianske cruzeiro novo (1967–1986)"
        },
        "narrow": "BRB",
        "symbol": "BRB"
      },
      "BRC": {
        "displayName": {
          "one": "brasiliansk cruzado (1986–1989)",
          "other": "brasilianske cruzado (1986–1989)"
        },
        "narrow": "BRC",
        "symbol": "BRC"
      },
      "BRE": {
        "displayName": {
          "one": "brasiliansk cruzeiro (1990–1993)",
          "other": "brasilianske cruzeiro (1990–1993)"
        },
        "narrow": "BRE",
        "symbol": "BRE"
      },
      "BRL": {
        "displayName": {
          "one": "brasiliansk real",
          "other": "brasilianske real"
        },
        "narrow": "R$",
        "symbol": "BRL"
      },
      "BRN": {
        "displayName": {
          "one": "brasiliansk cruzado novo (1989–1990)",
          "other": "brasilianske cruzado novo (1989–1990)"
        },
        "narrow": "BRN",
        "symbol": "BRN"
      },
      "BRR": {
        "displayName": {
          "one": "brasiliansk cruzeiro (1993–1994)",
          "other": "brasilianske cruzeiro (1993–1994)"
        },
        "narrow": "BRR",
        "symbol": "BRR"
      },
      "BRZ": {
        "displayName": {
          "one": "brasiliansk cruzeiro (1942–1967)",
          "other": "brasilianske cruzeiro (1942–1967)"
        },
        "narrow": "BRZ",
        "symbol": "BRZ"
      },
      "BSD": {
        "displayName": {
          "one": "bahamansk dollar",
          "other": "bahamanske dollar"
        },
        "narrow": "$",
        "symbol": "BSD"
      },
      "BTN": {
        "displayName": {
          "one": "bhutansk ngultrum",
          "other": "bhutanske ngultrum"
        },
        "narrow": "BTN",
        "symbol": "BTN"
      },
      "BUK": {
        "displayName": {
          "one": "burmesisk kyat",
          "other": "burmesiske kyat"
        },
        "narrow": "BUK",
        "symbol": "BUK"
      },
      "BWP": {
        "displayName": {
          "one": "botswansk pula",
          "other": "botswanske pula"
        },
        "narrow": "P",
        "symbol": "BWP"
      },
      "BYB": {
        "displayName": {
          "one": "hviterussisk ny rubel (1994–1999)",
          "other": "hviterussiske nye rubler (1994–1999)"
        },
        "narrow": "BYB",
        "symbol": "BYB"
      },
      "BYN": {
        "displayName": {
          "one": "ny belarusisk rubel",
          "other": "nye belarusiske rubler"
        },
        "narrow": "р.",
        "symbol": "BYN"
      },
      "BYR": {
        "displayName": {
          "one": "hviterussisk rubel (2000–2016)",
          "other": "hviterussiske rubler (2000–2016)"
        },
        "narrow": "BYR",
        "symbol": "BYR"
      },
      "BZD": {
        "displayName": {
          "one": "belizisk dollar",
          "other": "beliziske dollar"
        },
        "narrow": "$",
        "symbol": "BZD"
      },
      "CAD": {
        "displayName": {
          "one": "kanadisk dollar",
          "other": "kanadiske dollar"
        },
        "narrow": "$",
        "symbol": "CAD"
      },
      "CDF": {
        "displayName": {
          "one": "kongolesisk franc",
          "other": "kongolesiske franc"
        },
        "narrow": "CDF",
        "symbol": "CDF"
      },
      "CHE": {
        "displayName": {
          "other": "WIR-euro"
        },
        "narrow": "CHE",
        "symbol": "CHE"
      },
      "CHF": {
        "displayName": {
          "one": "sveitsisk franc",
          "other": "sveitsiske franc"
        },
        "narrow": "CHF",
        "symbol": "CHF"
      },
      "CHW": {
        "displayName": {
          "other": "WIR-franc"
        },
        "narrow": "CHW",
        "symbol": "CHW"
      },
      "CLE": {
        "displayName": {
          "one": "chilensk escudo",
          "other": "chilenske escudo"
        },
        "narrow": "CLE",
        "symbol": "CLE"
      },
      "CLF": {
        "displayName": {
          "one": "chilensk unidades de fomento",
          "other": "chilenske unidades de fomento"
        },
        "narrow": "CLF",
        "symbol": "CLF"
      },
      "CLP": {
        "displayName": {
          "one": "chilensk peso",
          "other": "chilenske pesos"
        },
        "narrow": "$",
        "symbol": "CLP"
      },
      "CNH": {
        "displayName": {
          "one": "kinesisk yuan (offshore)",
          "other": "kinesiske yuan (offshore)"
        },
        "narrow": "CNH",
        "symbol": "CNH"
      },
      "CNX": {
        "displayName": {
          "other": "Kinas folkebank dollar"
        },
        "narrow": "CNX",
        "symbol": "CNX"
      },
      "CNY": {
        "displayName": {
          "one": "kinesisk yuan",
          "other": "kinesiske yuan"
        },
        "narrow": "¥",
        "symbol": "CNY"
      },
      "COP": {
        "displayName": {
          "one": "colombiansk peso",
          "other": "colombianske pesos"
        },
        "narrow": "$",
        "symbol": "COP"
      },
      "COU": {
        "displayName": {
          "one": "colombiansk unidad de valor real",
          "other": "colombianske unidad de valor real"
        },
        "narrow": "COU",
        "symbol": "COU"
      },
      "CRC": {
        "displayName": {
          "one": "costaricansk colón",
          "other": "costaricanske colón"
        },
        "narrow": "₡",
        "symbol": "CRC"
      },
      "CSD": {
        "displayName": {
          "one": "serbisk dinar (2002–2006)",
          "other": "serbiske dinarer (2002–2006)"
        },
        "narrow": "CSD",
        "symbol": "CSD"
      },
      "CSK": {
        "displayName": {
          "one": "tsjekkoslovakisk koruna (hard)",
          "other": "tsjekkoslovakiske koruna (hard)"
        },
        "narrow": "CSK",
        "symbol": "CSK"
      },
      "CUC": {
        "displayName": {
          "one": "kubansk konvertibel peso",
          "other": "kubanske konvertible pesos"
        },
        "narrow": "$",
        "symbol": "CUC"
      },
      "CUP": {
        "displayName": {
          "one": "kubansk peso",
          "other": "kubanske pesos"
        },
        "narrow": "$",
        "symbol": "CUP"
      },
      "CVE": {
        "displayName": {
          "one": "kappverdisk escudo",
          "other": "kappverdiske escudos"
        },
        "narrow": "CVE",
        "symbol": "CVE"
      },
      "CYP": {
        "displayName": {
          "one": "kypriotisk pund",
          "other": "kypriotiske pund"
        },
        "narrow": "CYP",
        "symbol": "CYP"
      },
      "CZK": {
        "displayName": {
          "one": "tsjekkisk koruna",
          "other": "tsjekkiske koruna"
        },
        "narrow": "Kč",
        "symbol": "CZK"
      },
      "DDM": {
        "displayName": {
          "one": "østtysk mark",
          "other": "østtyske mark"
        },
        "narrow": "DDM",
        "symbol": "DDM"
      },
      "DEM": {
        "displayName": {
          "one": "tysk mark",
          "other": "tyske mark"
        },
        "narrow": "DEM",
        "symbol": "DEM"
      },
      "DJF": {
        "displayName": {
          "one": "djiboutisk franc",
          "other": "djiboutiske franc"
        },
        "narrow": "DJF",
        "symbol": "DJF"
      },
      "DKK": {
        "displayName": {
          "one": "dansk krone",
          "other": "danske kroner"
        },
        "narrow": "kr",
        "symbol": "DKK"
      },
      "DOP": {
        "displayName": {
          "one": "dominikansk peso",
          "other": "dominikanske pesos"
        },
        "narrow": "$",
        "symbol": "DOP"
      },
      "DZD": {
        "displayName": {
          "one": "algerisk dinar",
          "other": "algeriske dinarer"
        },
        "narrow": "DZD",
        "symbol": "DZD"
      },
      "ECS": {
        "displayName": {
          "one": "ecuadoriansk sucre",
          "other": "ecuadorianske sucre"
        },
        "narrow": "ECS",
        "symbol": "ECS"
      },
      "ECV": {
        "displayName": {
          "one": "ecuadoriansk unidad de valor constante (UVC)",
          "other": "ecuadorianske unidad de valor constante (UVC)"
        },
        "narrow": "ECV",
        "symbol": "ECV"
      },
      "EEK": {
        "displayName": {
          "one": "estisk kroon",
          "other": "estiske kroner"
        },
        "narrow": "EEK",
        "symbol": "EEK"
      },
      "EGP": {
        "displayName": {
          "one": "egyptisk pund",
          "other": "egyptiske pund"
        },
        "narrow": "E£",
        "symbol": "EGP"
      },
      "ERN": {
        "displayName": {
          "one": "eritreisk nakfa",
          "other": "eritreiske nakfa"
        },
        "narrow": "ERN",
        "symbol": "ERN"
      },
      "ESA": {
        "displayName": {
          "one": "spansk peseta (A–konto)",
          "other": "spanske peseta (A–konto)"
        },
        "narrow": "ESA",
        "symbol": "ESA"
      },
      "ESB": {
        "displayName": {
          "one": "spansk peseta (konvertibel konto)",
          "other": "spanske peseta (konvertibel konto)"
        },
        "narrow": "ESB",
        "symbol": "ESB"
      },
      "ESP": {
        "displayName": {
          "one": "spansk peseta",
          "other": "spanske peseta"
        },
        "narrow": "₧",
        "symbol": "ESP"
      },
      "ETB": {
        "displayName": {
          "one": "etiopisk birr",
          "other": "etiopiske birr"
        },
        "narrow": "ETB",
        "symbol": "ETB"
      },
      "EUR": {
        "displayName": {
          "other": "euro"
        },
        "narrow": "€",
        "symbol": "€"
      },
      "FIM": {
        "displayName": {
          "one": "finsk mark",
          "other": "finske mark"
        },
        "narrow": "FIM",
        "symbol": "FIM"
      },
      "FJD": {
        "displayName": {
          "one": "fijiansk dollar",
          "other": "fijianske dollar"
        },
        "narrow": "$",
        "symbol": "FJD"
      },
      "FKP": {
        "displayName": {
          "other": "falklandspund"
        },
        "narrow": "£",
        "symbol": "FKP"
      },
      "FRF": {
        "displayName": {
          "one": "fransk franc",
          "other": "franske franc"
        },
        "narrow": "FRF",
        "symbol": "FRF"
      },
      "GBP": {
        "displayName": {
          "one": "britisk pund",
          "other": "britiske pund"
        },
        "narrow": "£",
        "symbol": "£"
      },
      "GEK": {
        "displayName": {
          "one": "georgisk kupon larit",
          "other": "georgiske kupon larit"
        },
        "narrow": "GEK",
        "symbol": "GEK"
      },
      "GEL": {
        "displayName": {
          "one": "georgisk lari",
          "other": "georgiske lari"
        },
        "narrow": "₾",
        "symbol": "GEL"
      },
      "GHC": {
        "displayName": {
          "one": "ghanesisk cedi (1979–2007)",
          "other": "ghanesiske cedi (1979–2007)"
        },
        "narrow": "GHC",
        "symbol": "GHC"
      },
      "GHS": {
        "displayName": {
          "one": "ghanesisk cedi",
          "other": "ghanesiske cedi"
        },
        "narrow": "GH₵",
        "symbol": "GHS"
      },
      "GIP": {
        "displayName": {
          "one": "gibraltarsk pund",
          "other": "gibraltarske pund"
        },
        "narrow": "£",
        "symbol": "GIP"
      },
      "GMD": {
        "displayName": {
          "one": "gambisk dalasi",
          "other": "gambiske dalasi"
        },
        "narrow": "GMD",
        "symbol": "GMD"
      },
      "GNF": {
        "displayName": {
          "one": "guineansk franc",
          "other": "guineanske franc"
        },
        "narrow": "FG",
        "symbol": "GNF"
      },
      "GNS": {
        "displayName": {
          "one": "guineansk syli",
          "other": "guineanske syli"
        },
        "narrow": "GNS",
        "symbol": "GNS"
      },
      "GQE": {
        "displayName": {
          "one": "ekvatorialguineansk ekwele guineana",
          "other": "ekvatorialguineanske ekwele guineana"
        },
        "narrow": "GQE",
        "symbol": "GQE"
      },
      "GRD": {
        "displayName": {
          "one": "gresk drakme",
          "other": "greske drakmer"
        },
        "narrow": "GRD",
        "symbol": "GRD"
      },
      "GTQ": {
        "displayName": {
          "one": "guatemalansk quetzal",
          "other": "guatemalanske quetzal"
        },
        "narrow": "Q",
        "symbol": "GTQ"
      },
      "GWE": {
        "displayName": {
          "one": "portugisisk guinea escudo",
          "other": "portugisiske guinea escudo"
        },
        "narrow": "GWE",
        "symbol": "GWE"
      },
      "GWP": {
        "displayName": {
          "other": "Guinea-Bissau-pesos"
        },
        "narrow": "GWP",
        "symbol": "GWP"
      },
      "GYD": {
        "displayName": {
          "one": "guyansk dollar",
          "other": "guyanske dollar"
        },
        "narrow": "$",
        "symbol": "GYD"
      },
      "HKD": {
        "displayName": {
          "other": "Hongkong-dollar"
        },
        "narrow": "$",
        "symbol": "HKD"
      },
      "HNL": {
        "displayName": {
          "one": "honduransk lempira",
          "other": "honduranske lempira"
        },
        "narrow": "L",
        "symbol": "HNL"
      },
      "HRD": {
        "displayName": {
          "one": "kroatisk dinar",
          "other": "kroatiske dinarer"
        },
        "narrow": "HRD",
        "symbol": "HRD"
      },
      "HRK": {
        "displayName": {
          "one": "kroatisk kuna",
          "other": "kroatiske kuna"
        },
        "narrow": "kn",
        "symbol": "HRK"
      },
      "HTG": {
        "displayName": {
          "one": "haitisk gourde",
          "other": "haitiske gourde"
        },
        "narrow": "HTG",
        "symbol": "HTG"
      },
      "HUF": {
        "displayName": {
          "one": "ungarsk forint",
          "other": "ungarske forinter"
        },
        "narrow": "Ft",
        "symbol": "HUF"
      },
      "IDR": {
        "displayName": {
          "one": "indonesisk rupi",
          "other": "indonesiske rupier"
        },
        "narrow": "Rp",
        "symbol": "IDR"
      },
      "IEP": {
        "displayName": {
          "one": "irsk pund",
          "other": "irske pund"
        },
        "narrow": "IEP",
        "symbol": "IEP"
      },
      "ILP": {
        "displayName": {
          "one": "israelsk pund",
          "other": "israelske pund"
        },
        "narrow": "ILP",
        "symbol": "ILP"
      },
      "ILR": {
        "displayName": {
          "one": "israelsk shekel (1980–1985)",
          "other": "israelske shekler (1980–1985)"
        },
        "narrow": "ILR",
        "symbol": "ILR"
      },
      "ILS": {
        "displayName": {
          "one": "ny israelsk shekel",
          "other": "nye israelske shekler"
        },
        "narrow": "₪",
        "symbol": "ILS"
      },
      "INR": {
        "displayName": {
          "one": "indisk rupi",
          "other": "indiske rupier"
        },
        "narrow": "₹",
        "symbol": "INR"
      },
      "IQD": {
        "displayName": {
          "one": "iraksk dinar",
          "other": "irakske dinarer"
        },
        "narrow": "IQD",
        "symbol": "IQD"
      },
      "IRR": {
        "displayName": {
          "one": "iransk rial",
          "other": "iranske rialer"
        },
        "narrow": "IRR",
        "symbol": "IRR"
      },
      "ISJ": {
        "displayName": {
          "one": "islandsk krone (1918–1981)",
          "other": "islandske kroner (1918–1981)"
        },
        "narrow": "ISJ",
        "symbol": "ISJ"
      },
      "ISK": {
        "displayName": {
          "one": "islandsk krone",
          "other": "islandske kroner"
        },
        "narrow": "kr",
        "symbol": "ISK"
      },
      "ITL": {
        "displayName": {
          "one": "italiensk lire",
          "other": "italienske lire"
        },
        "narrow": "ITL",
        "symbol": "ITL"
      },
      "JMD": {
        "displayName": {
          "one": "jamaikansk dollar",
          "other": "jamaikanske dollar"
        },
        "narrow": "$",
        "symbol": "JMD"
      },
      "JOD": {
        "displayName": {
          "one": "jordansk dinar",
          "other": "jordanske dinarer"
        },
        "narrow": "JOD",
        "symbol": "JOD"
      },
      "JPY": {
        "displayName": {
          "one": "japansk yen",
          "other": "japanske yen"
        },
        "narrow": "¥",
        "symbol": "JPY"
      },
      "KES": {
        "displayName": {
          "one": "kenyansk shilling",
          "other": "kenyanske shilling"
        },
        "narrow": "KES",
        "symbol": "KES"
      },
      "KGS": {
        "displayName": {
          "one": "kirgisisk som",
          "other": "kirgisiske som"
        },
        "narrow": "⃀",
        "symbol": "KGS"
      },
      "KHR": {
        "displayName": {
          "one": "kambodsjansk riel",
          "other": "kambodsjanske riel"
        },
        "narrow": "៛",
        "symbol": "KHR"
      },
      "KMF": {
        "displayName": {
          "one": "komorisk franc",
          "other": "komoriske franc"
        },
        "narrow": "CF",
        "symbol": "KMF"
      },
      "KPW": {
        "displayName": {
          "one": "nordkoreansk won",
          "other": "nordkoreanske won"
        },
        "narrow": "₩",
        "symbol": "KPW"
      },
      "KRH": {
        "displayName": {
          "one": "sørkoreansk hwan (1953–1962)",
          "other": "sørkoreanske hwan (1953–1962)"
        },
        "narrow": "KRH",
        "symbol": "KRH"
      },
      "KRO": {
        "displayName": {
          "one": "sørkoreansk won (1945–1953)",
          "other": "sørkoreanske won (1945–1953)"
        },
        "narrow": "KRO",
        "symbol": "KRO"
      },
      "KRW": {
        "displayName": {
          "one": "sørkoreansk won",
          "other": "sørkoreanske won"
        },
        "narrow": "₩",
        "symbol": "KRW"
      },
      "KWD": {
        "displayName": {
          "one": "kuwaitisk dinar",
          "other": "kuwaitiske dinarer"
        },
        "narrow": "KWD",
        "symbol": "KWD"
      },
      "KYD": {
        "displayName": {
          "one": "caymansk dollar",
          "other": "caymanske dollar"
        },
        "narrow": "$",
        "symbol": "KYD"
      },
      "KZT": {
        "displayName": {
          "one": "kasakhstansk tenge",
          "other": "kasakhstanske tenge"
        },
        "narrow": "₸",
        "symbol": "KZT"
      },
      "LAK": {
        "displayName": {
          "one": "laotisk kip",
          "other": "laotiske kip"
        },
        "narrow": "₭",
        "symbol": "LAK"
      },
      "LBP": {
        "displayName": {
          "one": "libanesisk pund",
          "other": "libanesiske pund"
        },
        "narrow": "L£",
        "symbol": "LBP"
      },
      "LKR": {
        "displayName": {
          "one": "srilankisk rupi",
          "other": "srilankiske rupier"
        },
        "narrow": "Rs",
        "symbol": "LKR"
      },
      "LRD": {
        "displayName": {
          "one": "liberisk dollar",
          "other": "liberiske dollar"
        },
        "narrow": "$",
        "symbol": "LRD"
      },
      "LSL": {
        "displayName": {
          "one": "lesothisk loti",
          "other": "lesothiske loti"
        },
        "narrow": "LSL",
        "symbol": "LSL"
      },
      "LTL": {
        "displayName": {
          "one": "litauisk lita",
          "other": "litauiske lita"
        },
        "narrow": "Lt",
        "symbol": "LTL"
      },
      "LTT": {
        "displayName": {
          "one": "litauisk talonas",
          "other": "litauiske talonas"
        },
        "narrow": "LTT",
        "symbol": "LTT"
      },
      "LUC": {
        "displayName": {
          "one": "luxemburgsk konvertibel franc",
          "other": "luxemburgske konvertible franc"
        },
        "narrow": "LUC",
        "symbol": "LUC"
      },
      "LUF": {
        "displayName": {
          "one": "luxemburgsk franc",
          "other": "luxemburgske franc"
        },
        "narrow": "LUF",
        "symbol": "LUF"
      },
      "LUL": {
        "displayName": {
          "one": "luxemburgsk finansiell franc",
          "other": "luxemburgske finansielle franc"
        },
        "narrow": "LUL",
        "symbol": "LUL"
      },
      "LVL": {
        "displayName": {
          "one": "latvisk lats",
          "other": "latviske lats"
        },
        "narrow": "Ls",
        "symbol": "LVL"
      },
      "LVR": {
        "displayName": {
          "one": "latvisk rubel",
          "other": "latviske rubler"
        },
        "narrow": "LVR",
        "symbol": "LVR"
      },
      "LYD": {
        "displayName": {
          "one": "libysk dinar",
          "other": "libyske dinarer"
        },
        "narrow": "LYD",
        "symbol": "LYD"
      },
      "MAD": {
        "displayName": {
          "one": "marokkansk dirham",
          "other": "marokkanske dirham"
        },
        "narrow": "MAD",
        "symbol": "MAD"
      },
      "MAF": {
        "displayName": {
          "one": "marokkansk franc",
          "other": "marokkanske franc"
        },
        "narrow": "MAF",
        "symbol": "MAF"
      },
      "MCF": {
        "displayName": {
          "one": "monegaskisk franc",
          "other": "monegaskiske franc"
        },
        "narrow": "MCF",
        "symbol": "MCF"
      },
      "MDC": {
        "displayName": {
          "one": "moldovsk cupon",
          "other": "moldovske cupon"
        },
        "narrow": "MDC",
        "symbol": "MDC"
      },
      "MDL": {
        "displayName": {
          "one": "moldovsk leu",
          "other": "moldovske lei"
        },
        "narrow": "MDL",
        "symbol": "MDL"
      },
      "MGA": {
        "displayName": {
          "one": "madagassisk ariary",
          "other": "madagassiske ariary"
        },
        "narrow": "Ar",
        "symbol": "MGA"
      },
      "MGF": {
        "displayName": {
          "one": "madagassisk franc",
          "other": "madagassiske franc"
        },
        "narrow": "MGF",
        "symbol": "MGF"
      },
      "MKD": {
        "displayName": {
          "one": "makedonsk denar",
          "other": "makedonske denarer"
        },
        "narrow": "MKD",
        "symbol": "MKD"
      },
      "MKN": {
        "displayName": {
          "one": "makedonsk denar (1992–1993)",
          "other": "makedonske denarer (1992–1993)"
        },
        "narrow": "MKN",
        "symbol": "MKN"
      },
      "MLF": {
        "displayName": {
          "one": "malisk franc",
          "other": "maliske franc"
        },
        "narrow": "MLF",
        "symbol": "MLF"
      },
      "MMK": {
        "displayName": {
          "one": "myanmarsk kyat",
          "other": "myanmarske kyat"
        },
        "narrow": "K",
        "symbol": "MMK"
      },
      "MNT": {
        "displayName": {
          "one": "mongolsk tugrik",
          "other": "mongolske tugrik"
        },
        "narrow": "₮",
        "symbol": "MNT"
      },
      "MOP": {
        "displayName": {
          "one": "makaoisk pataca",
          "other": "makaoiske pataca"
        },
        "narrow": "MOP",
        "symbol": "MOP"
      },
      "MRO": {
        "displayName": {
          "one": "mauritansk ouguiya (1973–2017)",
          "other": "mauritanske ouguiya (1973–2017)"
        },
        "narrow": "MRO",
        "symbol": "MRO"
      },
      "MRU": {
        "displayName": {
          "one": "mauritansk ouguiya",
          "other": "mauritanske ouguiya"
        },
        "narrow": "MRU",
        "symbol": "MRU"
      },
      "MTL": {
        "displayName": {
          "one": "maltesisk lira",
          "other": "maltesiske lira"
        },
        "narrow": "MTL",
        "symbol": "MTL"
      },
      "MTP": {
        "displayName": {
          "one": "maltesisk pund",
          "other": "maltesiske pund"
        },
        "narrow": "MTP",
        "symbol": "MTP"
      },
      "MUR": {
        "displayName": {
          "one": "mauritisk rupi",
          "other": "mauritiske rupier"
        },
        "narrow": "Rs",
        "symbol": "MUR"
      },
      "MVP": {
        "displayName": {
          "one": "maldivisk rupi",
          "other": "maldiviske rupier"
        },
        "narrow": "MVP",
        "symbol": "MVP"
      },
      "MVR": {
        "displayName": {
          "one": "maldivisk rufiyaa",
          "other": "maldiviske rufiyaa"
        },
        "narrow": "MVR",
        "symbol": "MVR"
      },
      "MWK": {
        "displayName": {
          "one": "malawisk kwacha",
          "other": "malawiske kwacha"
        },
        "narrow": "MWK",
        "symbol": "MWK"
      },
      "MXN": {
        "displayName": {
          "one": "meksikansk peso",
          "other": "meksikanske pesos"
        },
        "narrow": "$",
        "symbol": "MXN"
      },
      "MXP": {
        "displayName": {
          "one": "meksikansk sølvpesos (1860–1992)",
          "other": "meksikanske sølvpesos (1860–1992)"
        },
        "narrow": "MXP",
        "symbol": "MXP"
      },
      "MXV": {
        "displayName": {
          "one": "meksikansk unidad de inversion (UDI)",
          "other": "meksikanske unidad de inversion (UDI)"
        },
        "narrow": "MXV",
        "symbol": "MXV"
      },
      "MYR": {
        "displayName": {
          "one": "malaysisk ringgit",
          "other": "malaysiske ringgit"
        },
        "narrow": "RM",
        "symbol": "MYR"
      },
      "MZE": {
        "displayName": {
          "one": "mosambikisk escudo",
          "other": "mosambikiske escudo"
        },
        "narrow": "MZE",
        "symbol": "MZE"
      },
      "MZM": {
        "displayName": {
          "one": "gammel mosambikisk metical",
          "other": "gamle mosambikiske metical"
        },
        "narrow": "MZM",
        "symbol": "MZM"
      },
      "MZN": {
        "displayName": {
          "one": "mosambikisk metical",
          "other": "mosambikiske metical"
        },
        "narrow": "MZN",
        "symbol": "MZN"
      },
      "NAD": {
        "displayName": {
          "one": "namibisk dollar",
          "other": "namibiske dollar"
        },
        "narrow": "$",
        "symbol": "NAD"
      },
      "NGN": {
        "displayName": {
          "one": "nigeriansk naira",
          "other": "nigerianske naira"
        },
        "narrow": "₦",
        "symbol": "NGN"
      },
      "NIC": {
        "displayName": {
          "one": "nicaraguansk cordoba (1988–1991)",
          "other": "nicaraguanske cordoba (1988–1991)"
        },
        "narrow": "NIC",
        "symbol": "NIC"
      },
      "NIO": {
        "displayName": {
          "one": "nicaraguansk córdoba",
          "other": "nicaraguanske córdoba"
        },
        "narrow": "C$",
        "symbol": "NIO"
      },
      "NLG": {
        "displayName": {
          "one": "nederlandsk gylden",
          "other": "nederlandske gylden"
        },
        "narrow": "NLG",
        "symbol": "NLG"
      },
      "NOK": {
        "displayName": {
          "one": "norsk krone",
          "other": "norske kroner"
        },
        "narrow": "kr",
        "symbol": "kr"
      },
      "NPR": {
        "displayName": {
          "one": "nepalsk rupi",
          "other": "nepalske rupier"
        },
        "narrow": "Rs",
        "symbol": "NPR"
      },
      "NZD": {
        "displayName": {
          "one": "newzealandsk dollar",
          "other": "newzealandske dollar"
        },
        "narrow": "$",
        "symbol": "NZD"
      },
      "OMR": {
        "displayName": {
          "one": "omansk rial",
          "other": "omanske rialer"
        },
        "narrow": "OMR",
        "symbol": "OMR"
      },
      "PAB": {
        "displayName": {
          "one": "panamansk balboa",
          "other": "panamanske balboa"
        },
        "narrow": "PAB",
        "symbol": "PAB"
      },
      "PEI": {
        "displayName": {
          "one": "peruansk inti",
          "other": "peruanske inti"
        },
        "narrow": "PEI",
        "symbol": "PEI"
      },
      "PEN": {
        "displayName": {
          "one": "peruansk sol",
          "other": "peruanske sol"
        },
        "narrow": "PEN",
        "symbol": "PEN"
      },
      "PES": {
        "displayName": {
          "one": "peruansk sol (1863–1965)",
          "other": "peruanske sol (1863–1965)"
        },
        "narrow": "PES",
        "symbol": "PES"
      },
      "PGK": {
        "displayName": {
          "one": "papuansk kina",
          "other": "papuanske kina"
        },
        "narrow": "PGK",
        "symbol": "PGK"
      },
      "PHP": {
        "displayName": {
          "one": "filippinsk peso",
          "other": "filippinske pesos"
        },
        "narrow": "₱",
        "symbol": "PHP"
      },
      "PKR": {
        "displayName": {
          "one": "pakistansk rupi",
          "other": "pakistanske rupier"
        },
        "narrow": "Rs",
        "symbol": "PKR"
      },
      "PLN": {
        "displayName": {
          "one": "polsk zloty",
          "other": "polske zloty"
        },
        "narrow": "zł",
        "symbol": "PLN"
      },
      "PLZ": {
        "displayName": {
          "one": "polsk zloty (1950–1995)",
          "other": "polske zloty (1950–1995)"
        },
        "narrow": "PLZ",
        "symbol": "PLZ"
      },
      "PTE": {
        "displayName": {
          "one": "portugisisk escudo",
          "other": "portugisiske escudo"
        },
        "narrow": "PTE",
        "symbol": "PTE"
      },
      "PYG": {
        "displayName": {
          "one": "paraguayansk guarani",
          "other": "paraguayanske guarani"
        },
        "narrow": "₲",
        "symbol": "PYG"
      },
      "QAR": {
        "displayName": {
          "one": "qatarsk rial",
          "other": "qatarske rialer"
        },
        "narrow": "QAR",
        "symbol": "QAR"
      },
      "RHD": {
        "displayName": {
          "one": "rhodesisk dollar",
          "other": "rhodesiske dollar"
        },
        "narrow": "RHD",
        "symbol": "RHD"
      },
      "ROL": {
        "displayName": {
          "one": "rumensk leu (1952–2006)",
          "other": "rumenske leu (1952–2006)"
        },
        "narrow": "ROL",
        "symbol": "ROL"
      },
      "RON": {
        "displayName": {
          "one": "rumensk leu",
          "other": "rumenske lei"
        },
        "narrow": "L",
        "symbol": "RON"
      },
      "RSD": {
        "displayName": {
          "one": "serbisk dinar",
          "other": "serbiske dinarer"
        },
        "narrow": "RSD",
        "symbol": "RSD"
      },
      "RUB": {
        "displayName": {
          "one": "russisk rubel",
          "other": "russiske rubler"
        },
        "narrow": "₽",
        "symbol": "RUB"
      },
      "RUR": {
        "displayName": {
          "one": "russisk rubel (1991–1998)",
          "other": "russiske rubler (1991–1998)"
        },
        "narrow": "RUR",
        "symbol": "RUR"
      },
      "RWF": {
        "displayName": {
          "one": "rwandisk franc",
          "other": "rwandiske franc"
        },
        "narrow": "RF",
        "symbol": "RWF"
      },
      "SAR": {
        "displayName": {
          "one": "saudiarabisk riyal",
          "other": "saudiarabiske riyaler"
        },
        "narrow": "SAR",
        "symbol": "SAR"
      },
      "SBD": {
        "displayName": {
          "one": "salomonsk dollar",
          "other": "salomonske dollar"
        },
        "narrow": "$",
        "symbol": "SBD"
      },
      "SCR": {
        "displayName": {
          "one": "seychellisk rupi",
          "other": "seychelliske rupier"
        },
        "narrow": "SCR",
        "symbol": "SCR"
      },
      "SDD": {
        "displayName": {
          "one": "sudanesisk dinar (1992–2007)",
          "other": "sudanesiske dinarer (1992–2007)"
        },
        "narrow": "SDD",
        "symbol": "SDD"
      },
      "SDG": {
        "displayName": {
          "one": "sudansk pund",
          "other": "sudanske pund"
        },
        "narrow": "SDG",
        "symbol": "SDG"
      },
      "SDP": {
        "displayName": {
          "one": "sudansk pund (1957–1998)",
          "other": "sudanske pund (1957–1998)"
        },
        "narrow": "SDP",
        "symbol": "SDP"
      },
      "SEK": {
        "displayName": {
          "one": "svensk krone",
          "other": "svenske kroner"
        },
        "narrow": "kr",
        "symbol": "SEK"
      },
      "SGD": {
        "displayName": {
          "one": "singaporsk dollar",
          "other": "singaporske dollar"
        },
        "narrow": "$",
        "symbol": "SGD"
      },
      "SHP": {
        "displayName": {
          "one": "sankthelensk pund",
          "other": "sankthelenske pund"
        },
        "narrow": "£",
        "symbol": "SHP"
      },
      "SIT": {
        "displayName": {
          "one": "slovensk tolar",
          "other": "slovenske tolar"
        },
        "narrow": "SIT",
        "symbol": "SIT"
      },
      "SKK": {
        "displayName": {
          "one": "slovakisk koruna",
          "other": "slovakiske koruna"
        },
        "narrow": "SKK",
        "symbol": "SKK"
      },
      "SLE": {
        "displayName": {
          "one": "sierraleonsk leone",
          "other": "sierraleonske leoner"
        },
        "narrow": "SLE",
        "symbol": "SLE"
      },
      "SLL": {
        "displayName": {
          "one": "sierraleonsk leone (1964–2022)",
          "other": "sierraleonske leoner (1964–2022)"
        },
        "narrow": "SLL",
        "symbol": "SLL"
      },
      "SOS": {
        "displayName": {
          "one": "somalisk shilling",
          "other": "somaliske shilling"
        },
        "narrow": "SOS",
        "symbol": "SOS"
      },
      "SRD": {
        "displayName": {
          "one": "surinamsk dollar",
          "other": "surinamske dollar"
        },
        "narrow": "$",
        "symbol": "SRD"
      },
      "SRG": {
        "displayName": {
          "one": "surinamsk gylden",
          "other": "surinamske gylden"
        },
        "narrow": "SRG",
        "symbol": "SRG"
      },
      "SSP": {
        "displayName": {
          "one": "sørsudansk pund",
          "other": "sørsudanske pund"
        },
        "narrow": "£",
        "symbol": "SSP"
      },
      "STD": {
        "displayName": {
          "one": "saotomesisk dobra (1977–2017)",
          "other": "saotomesiske dobra (1977–2017)"
        },
        "narrow": "STD",
        "symbol": "STD"
      },
      "STN": {
        "displayName": {
          "one": "saotomesisk dobra",
          "other": "saotomesiske dobra"
        },
        "narrow": "Db",
        "symbol": "STN"
      },
      "SUR": {
        "displayName": {
          "one": "sovjetisk rubel",
          "other": "sovjetiske rubler"
        },
        "narrow": "SUR",
        "symbol": "SUR"
      },
      "SVC": {
        "displayName": {
          "one": "salvadoransk colon",
          "other": "salvadoranske colon"
        },
        "narrow": "SVC",
        "symbol": "SVC"
      },
      "SYP": {
        "displayName": {
          "one": "syrisk pund",
          "other": "syriske pund"
        },
        "narrow": "£",
        "symbol": "SYP"
      },
      "SZL": {
        "displayName": {
          "one": "swazilandsk lilangeni",
          "other": "swazilandske lilangeni"
        },
        "narrow": "SZL",
        "symbol": "SZL"
      },
      "THB": {
        "displayName": {
          "one": "thailandsk baht",
          "other": "thailandske baht"
        },
        "narrow": "฿",
        "symbol": "THB"
      },
      "TJR": {
        "displayName": {
          "one": "tadsjikisk rubel",
          "other": "tadsjikiske rubler"
        },
        "narrow": "TJR",
        "symbol": "TJR"
      },
      "TJS": {
        "displayName": {
          "one": "tadsjikisk somoni",
          "other": "tadsjikiske somoni"
        },
        "narrow": "TJS",
        "symbol": "TJS"
      },
      "TMM": {
        "displayName": {
          "one": "turkmensk manat (1993–2009)",
          "other": "turkmenske manat (1993–2009)"
        },
        "narrow": "TMM",
        "symbol": "TMM"
      },
      "TMT": {
        "displayName": {
          "one": "turkmensk manat",
          "other": "turkmenske manat"
        },
        "narrow": "TMT",
        "symbol": "TMT"
      },
      "TND": {
        "displayName": {
          "one": "tunisisk dinar",
          "other": "tunisiske dinarer"
        },
        "narrow": "TND",
        "symbol": "TND"
      },
      "TOP": {
        "displayName": {
          "one": "tongansk paʻanga",
          "other": "tonganske paʻanga"
        },
        "narrow": "T$",
        "symbol": "TOP"
      },
      "TPE": {
        "displayName": {
          "one": "timoresisk escudo",
          "other": "timoresiske escudo"
        },
        "narrow": "TPE",
        "symbol": "TPE"
      },
      "TRL": {
        "displayName": {
          "one": "tyrkisk lire (1922–2005)",
          "other": "tyrkiske lire (1922–2005)"
        },
        "narrow": "TRL",
        "symbol": "TRL"
      },
      "TRY": {
        "displayName": {
          "one": "tyrkisk lire",
          "other": "tyrkiske lire"
        },
        "narrow": "₺",
        "symbol": "TRY"
      },
      "TTD": {
        "displayName": {
          "one": "trinidadisk dollar",
          "other": "trinidadiske dollar"
        },
        "narrow": "$",
        "symbol": "TTD"
      },
      "TWD": {
        "displayName": {
          "one": "ny taiwansk dollar",
          "other": "nye taiwanske dollar"
        },
        "narrow": "NT$",
        "symbol": "TWD"
      },
      "TZS": {
        "displayName": {
          "one": "tanzaniansk shilling",
          "other": "tanzanianske shilling"
        },
        "narrow": "TZS",
        "symbol": "TZS"
      },
      "UAH": {
        "displayName": {
          "one": "ukrainsk hryvnia",
          "other": "ukrainske hryvnia"
        },
        "narrow": "₴",
        "symbol": "UAH"
      },
      "UAK": {
        "displayName": {
          "one": "ukrainsk karbovanetz",
          "other": "ukrainske karbovanetz"
        },
        "narrow": "UAK",
        "symbol": "UAK"
      },
      "UGS": {
        "displayName": {
          "one": "ugandisk shilling (1966–1987)",
          "other": "ugandiske shilling (1966–1987)"
        },
        "narrow": "UGS",
        "symbol": "UGS"
      },
      "UGX": {
        "displayName": {
          "one": "ugandisk shilling",
          "other": "ugandiske shilling"
        },
        "narrow": "UGX",
        "symbol": "UGX"
      },
      "USD": {
        "displayName": {
          "one": "amerikansk dollar",
          "other": "amerikanske dollar"
        },
        "narrow": "$",
        "symbol": "USD"
      },
      "USN": {
        "displayName": {
          "one": "amerikansk dollar (neste dag)",
          "other": "amerikanske dollar (neste dag)"
        },
        "narrow": "USN",
        "symbol": "USN"
      },
      "USS": {
        "displayName": {
          "one": "amerikansk dollar (samme dag)",
          "other": "amerikanske dollar (samme dag)"
        },
        "narrow": "USS",
        "symbol": "USS"
      },
      "UYI": {
        "displayName": {
          "other": "uruguyanske pesos (indekserte enheter)"
        },
        "narrow": "UYI",
        "symbol": "UYI"
      },
      "UYP": {
        "displayName": {
          "one": "uruguayansk peso (1975–1993)",
          "other": "uruguayanske pesos (1975–1993)"
        },
        "narrow": "UYP",
        "symbol": "UYP"
      },
      "UYU": {
        "displayName": {
          "one": "uruguyansk peso",
          "other": "uruguayanske pesos"
        },
        "narrow": "$",
        "symbol": "UYU"
      },
      "UZS": {
        "displayName": {
          "one": "usbekisk som",
          "other": "usbekiske som"
        },
        "narrow": "UZS",
        "symbol": "UZS"
      },
      "VEB": {
        "displayName": {
          "one": "venezuelansk bolivar (1871–2008)",
          "other": "venezuelanske bolivar (1871–2008)"
        },
        "narrow": "VEB",
        "symbol": "VEB"
      },
      "VEF": {
        "displayName": {
          "one": "venezuelansk bolivar (2008–2018)",
          "other": "venezuelanske bolivar (2008–2018)"
        },
        "narrow": "Bs",
        "symbol": "VEF"
      },
      "VES": {
        "displayName": {
          "one": "venezuelansk bolivar",
          "other": "venezuelanske bolivar"
        },
        "narrow": "VES",
        "symbol": "VES"
      },
      "VND": {
        "displayName": {
          "one": "vietnamesisk dong",
          "other": "vietnamesiske dong"
        },
        "narrow": "₫",
        "symbol": "VND"
      },
      "VNN": {
        "displayName": {
          "one": "vietnamesisk dong (1978–1985)",
          "other": "vietnamesiske dong (1978–1985)"
        },
        "narrow": "VNN",
        "symbol": "VNN"
      },
      "VUV": {
        "displayName": {
          "one": "vanuatisk vatu",
          "other": "vanuatiske vatu"
        },
        "narrow": "VUV",
        "symbol": "VUV"
      },
      "WST": {
        "displayName": {
          "one": "samoansk tala",
          "other": "samoanske tala"
        },
        "narrow": "WST",
        "symbol": "WST"
      },
      "XAF": {
        "displayName": {
          "one": "sentralafrikansk CFA-franc",
          "other": "sentralafrikanske CFA-franc"
        },
        "narrow": "XAF",
        "symbol": "XAF"
      },
      "XAG": {
        "displayName": {
          "one": "unse sølv",
          "other": "unser sølv"
        },
        "narrow": "XAG",
        "symbol": "XAG"
      },
      "XAU": {
        "displayName": {
          "one": "unse gull",
          "other": "unser gull"
        },
        "narrow": "XAU",
        "symbol": "XAU"
      },
      "XBA": {
        "displayName": {
          "one": "europeisk sammensatt enhet",
          "other": "europeiske sammensatte enheter"
        },
        "narrow": "XBA",
        "symbol": "XBA"
      },
      "XBB": {
        "displayName": {
          "one": "europeisk monetær enhet",
          "other": "europeiske monetære enheter"
        },
        "narrow": "XBB",
        "symbol": "XBB"
      },
      "XBC": {
        "displayName": {
          "one": "europeisk kontoenhet (XBC)",
          "other": "europeiske kontoenheter"
        },
        "narrow": "XBC",
        "symbol": "XBC"
      },
      "XBD": {
        "displayName": {
          "one": "europeisk kontoenhet (XBD)",
          "other": "europeiske kontoenheter (XBD)"
        },
        "narrow": "XBD",
        "symbol": "XBD"
      },
      "XCD": {
        "displayName": {
          "one": "østkaribisk dollar",
          "other": "østkaribiske dollar"
        },
        "narrow": "$",
        "symbol": "XCD"
      },
      "XCG": {
        "displayName": {
        },
        "narrow": "Cg.",
        "symbol": "Cg."
      },
      "XDR": {
        "displayName": {
          "one": "spesiell trekkrettighet",
          "other": "spesielle trekkrettigheter"
        },
        "narrow": "XDR",
        "symbol": "XDR"
      },
      "XEU": {
        "displayName": {
          "one": "europeisk valutaenhet",
          "other": "europeiske valutaenheter"
        },
        "narrow": "XEU",
        "symbol": "XEU"
      },
      "XFO": {
        "displayName": {
          "one": "fransk gullfranc",
          "other": "franske gullfranc"
        },
        "narrow": "XFO",
        "symbol": "XFO"
      },
      "XFU": {
        "displayName": {
          "one": "fransk UIC-franc",
          "other": "franske UIC-franc"
        },
        "narrow": "XFU",
        "symbol": "XFU"
      },
      "XOF": {
        "displayName": {
          "one": "vestafrikansk CFA-franc",
          "other": "vestafrikanske CFA-franc"
        },
        "narrow": "F CFA",
        "symbol": "F CFA"
      },
      "XPD": {
        "displayName": {
          "one": "unse palladium",
          "other": "unser palladium"
        },
        "narrow": "XPD",
        "symbol": "XPD"
      },
      "XPF": {
        "displayName": {
          "other": "CFP-franc"
        },
        "narrow": "XPF",
        "symbol": "XPF"
      },
      "XPT": {
        "displayName": {
          "one": "unse platina",
          "other": "unser platina"
        },
        "narrow": "XPT",
        "symbol": "XPT"
      },
      "XRE": {
        "displayName": {
          "other": "RINET-fond"
        },
        "narrow": "XRE",
        "symbol": "XRE"
      },
      "XSU": {
        "displayName": {
          "other": "sucre"
        },
        "narrow": "XSU",
        "symbol": "XSU"
      },
      "XTS": {
        "displayName": {
          "other": "testvaluta"
        },
        "narrow": "XTS",
        "symbol": "XTS"
      },
      "XUA": {
        "displayName": {
          "one": "ADB-kontoenhet",
          "other": "ADB-kontoenheter"
        },
        "narrow": "XUA",
        "symbol": "XUA"
      },
      "XXX": {
        "displayName": {
          "other": "(ukjent valuta)"
        },
        "narrow": "XXX",
        "symbol": "XXX"
      },
      "YDD": {
        "displayName": {
          "one": "jemenittisk dinar",
          "other": "jemenittiske dinarer"
        },
        "narrow": "YDD",
        "symbol": "YDD"
      },
      "YER": {
        "displayName": {
          "one": "jemenittisk rial",
          "other": "jemenittiske rialer"
        },
        "narrow": "YER",
        "symbol": "YER"
      },
      "YUD": {
        "displayName": {
          "one": "jugoslavisk dinar (hard)",
          "other": "jugoslaviske dinarer (hard)"
        },
        "narrow": "YUD",
        "symbol": "YUD"
      },
      "YUM": {
        "displayName": {
          "one": "jugoslavisk noviy-dinar",
          "other": "jugoslaviske noviy-dinarer"
        },
        "narrow": "YUM",
        "symbol": "YUM"
      },
      "YUN": {
        "displayName": {
          "one": "jugoslavisk konvertibel dinar",
          "other": "jugoslaviske konvertible dinarer"
        },
        "narrow": "YUN",
        "symbol": "YUN"
      },
      "YUR": {
        "displayName": {
          "one": "jugoslavisk reformert dinar (1992–1993)",
          "other": "jugoslaviske reformerte dinarer (1992–1993)"
        },
        "narrow": "YUR",
        "symbol": "YUR"
      },
      "ZAL": {
        "displayName": {
          "one": "sørafrikansk rand (finansiell)",
          "other": "sørafrikanske rand (finansielle)"
        },
        "narrow": "ZAL",
        "symbol": "ZAL"
      },
      "ZAR": {
        "displayName": {
          "one": "sørafrikansk rand",
          "other": "sørafrikanske rand"
        },
        "narrow": "R",
        "symbol": "ZAR"
      },
      "ZMK": {
        "displayName": {
          "one": "zambisk kwacha (1968–2012)",
          "other": "zambiske kwacha (1968–2012)"
        },
        "narrow": "ZMK",
        "symbol": "ZMK"
      },
      "ZMW": {
        "displayName": {
          "one": "zambisk kwacha",
          "other": "zambiske kwacha"
        },
        "narrow": "ZK",
        "symbol": "ZMW"
      },
      "ZRN": {
        "displayName": {
          "one": "zairisk ny zaire",
          "other": "zairiske nye zaire"
        },
        "narrow": "ZRN",
        "symbol": "ZRN"
      },
      "ZRZ": {
        "displayName": {
          "one": "zairisk zaire",
          "other": "zairiske zaire"
        },
        "narrow": "ZRZ",
        "symbol": "ZRZ"
      },
      "ZWD": {
        "displayName": {
          "one": "zimbabwisk dollar (1980–2008)",
          "other": "zimbabwiske dollar (1980–2008)"
        },
        "narrow": "ZWD",
        "symbol": "ZWD"
      },
      "ZWL": {
        "displayName": {
          "one": "zimbabwisk dollar (2009)",
          "other": "zimbabwiske dollar (2009)"
        },
        "narrow": "ZWL",
        "symbol": "ZWL"
      },
      "ZWR": {
        "displayName": {
          "one": "zimbabwisk dollar (2008)",
          "other": "zimbabwiske dollar (2008)"
        },
        "narrow": "ZWR",
        "symbol": "ZWR"
      }
    },
    "nu": [
      "latn"
    ],
    "numbers": {
      "currency": {
        "latn": {
          "accounting": "¤ #,##0.00;(¤ #,##0.00)",
          "currencySpacing": {
            "afterInsertBetween": " ",
            "beforeInsertBetween": " "
          },
          "short": {
            "1000": {
              "other": "¤ 0k"
            },
            "10000": {
              "other": "¤ 00k"
            },
            "100000": {
              "other": "¤ 000k"
            },
            "1000000": {
              "other": "¤ 0 mill'.'"
            },
            "10000000": {
              "other": "¤ 00 mill'.'"
            },
            "100000000": {
              "other": "¤ 000 mill'.'"
            },
            "1000000000": {
              "other": "¤ 0 mrd'.'"
            },
            "10000000000": {
              "other": "¤ 00 mrd'.'"
            },
            "100000000000": {
              "other": "¤ 000 mrd'.'"
            },
            "1000000000000": {
              "other": "¤ 0 bill'.'"
            },
            "10000000000000": {
              "other": "¤ 00 bill'.'"
            },
            "100000000000000": {
              "other": "¤ 000 bill'.'"
            }
          },
          "standard": "#,##0.00 ¤;-#,##0.00 ¤",
          "unitPattern": "{0} {1}"
        }
      },
      "decimal": {
        "latn": {
          "long": {
            "1000": {
              "other": "0 tusen"
            },
            "10000": {
              "other": "00 tusen"
            },
            "100000": {
              "other": "000 tusen"
            },
            "1000000": {
              "one": "0 million",
              "other": "0 millioner"
            },
            "10000000": {
              "other": "00 millioner"
            },
            "100000000": {
              "other": "000 millioner"
            },
            "1000000000": {
              "one": "0 milliard",
              "other": "0 milliarder"
            },
            "10000000000": {
              "other": "00 milliarder"
            },
            "100000000000": {
              "other": "000 milliarder"
            },
            "1000000000000": {
              "one": "0 billion",
              "other": "0 billioner"
            },
            "10000000000000": {
              "other": "00 billioner"
            },
            "100000000000000": {
              "other": "000 billioner"
            }
          },
          "short": {
            "1000": {
              "other": "0k"
            },
            "10000": {
              "other": "00k"
            },
            "100000": {
              "other": "000k"
            },
            "1000000": {
              "other": "0 mill'.'"
            },
            "10000000": {
              "other": "00 mill'.'"
            },
            "100000000": {
              "other": "000 mill'.'"
            },
            "1000000000": {
              "other": "0 mrd'.'"
            },
            "10000000000": {
              "other": "00 mrd'.'"
            },
            "100000000000": {
              "other": "000 mrd'.'"
            },
            "1000000000000": {
              "other": "0 bill'.'"
            },
            "10000000000000": {
              "other": "00 bill'.'"
            },
            "100000000000000": {
              "other": "000 bill'.'"
            }
          },
          "standard": "#,##0.###"
        }
      },
      "nu": [
        "latn"
      ],
      "percent": {
        "latn": "#,##0 %"
      },
      "symbols": {
        "latn": {
          "approximatelySign": "ca.",
          "decimal": ",",
          "exponential": "E",
          "group": " ",
          "infinity": "∞",
          "list": ";",
          "minusSign": "−",
          "nan": "NaN",
          "perMille": "‰",
          "percentSign": "%",
          "plusSign": "+",
          "rangeSign": "–",
          "superscriptingExponent": "×",
          "timeSeparator": ":",
          "timeSeparator-alt-variant": "."
        }
      }
    },
    "units": {
      "compound": {
        "per": {
          "long": "{0} per {1}",
          "narrow": "{0}/{1}",
          "short": "{0}/{1}"
        }
      },
      "simple": {
        "acre": {
          "long": {
            "other": "{0} acre"
          },
          "narrow": {
            "other": "{0} ac"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ac"
          }
        },
        "bit": {
          "long": {
            "other": "{0} bit"
          },
          "narrow": {
            "other": "{0}bit"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} bit"
          }
        },
        "byte": {
          "long": {
            "other": "{0} byte"
          },
          "narrow": {
            "other": "{0}B"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} B"
          }
        },
        "celsius": {
          "long": {
            "one": "{0} grad celsius",
            "other": "{0} grader celsius"
          },
          "narrow": {
            "other": "{0} °C"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} °C"
          }
        },
        "centimeter": {
          "long": {
            "other": "{0} centimeter"
          },
          "narrow": {
            "other": "{0}cm"
          },
          "perUnit": {
            "long": "{0} per centimeter",
            "narrow": "{0}/cm",
            "short": "{0}/cm"
          },
          "short": {
            "other": "{0} cm"
          }
        },
        "day": {
          "long": {
            "other": "{0} døgn"
          },
          "narrow": {
            "other": "{0}d"
          },
          "perUnit": {
            "long": "{0} per døgn",
            "narrow": "{0}/d",
            "short": "{0}/d"
          },
          "short": {
            "other": "{0} d"
          }
        },
        "degree": {
          "long": {
            "one": "{0} grad",
            "other": "{0} grader"
          },
          "narrow": {
            "other": "{0}°"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°"
          }
        },
        "fahrenheit": {
          "long": {
            "one": "{0} grad fahrenheit",
            "other": "{0} grader fahrenheit"
          },
          "narrow": {
            "other": "{0}°F"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} °F"
          }
        },
        "fluid-ounce": {
          "long": {
            "one": "{0} væskeunse",
            "other": "{0} væskeunser"
          },
          "narrow": {
            "other": "{0} fl oz"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} fl oz"
          }
        },
        "foot": {
          "long": {
            "other": "{0} fot"
          },
          "narrow": {
            "other": "{0}ft"
          },
          "perUnit": {
            "long": "{0} per fot",
            "narrow": "{0}/ft",
            "short": "{0}/fot"
          },
          "short": {
            "other": "{0} fot"
          }
        },
        "gallon": {
          "long": {
            "other": "{0} gallon"
          },
          "narrow": {
            "other": "{0} gal"
          },
          "perUnit": {
            "long": "{0} per gallon",
            "narrow": "{0}/gal",
            "short": "{0}/gal"
          },
          "short": {
            "other": "{0} gal"
          }
        },
        "gigabit": {
          "long": {
            "other": "{0} gigabit"
          },
          "narrow": {
            "other": "{0}Gb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Gb"
          }
        },
        "gigabyte": {
          "long": {
            "other": "{0} gigabyte"
          },
          "narrow": {
            "other": "{0}GB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} GB"
          }
        },
        "gram": {
          "long": {
            "other": "{0} gram"
          },
          "narrow": {
            "other": "{0}g"
          },
          "perUnit": {
            "long": "{0} per gram",
            "narrow": "{0}/g",
            "short": "{0}/g"
          },
          "short": {
            "other": "{0} g"
          }
        },
        "hectare": {
          "long": {
            "other": "{0} hektar"
          },
          "narrow": {
            "other": "{0}ha"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ha"
          }
        },
        "hour": {
          "long": {
            "one": "{0} time",
            "other": "{0} timer"
          },
          "narrow": {
            "other": "{0}t"
          },
          "perUnit": {
            "long": "{0} per time",
            "narrow": "{0}/t",
            "short": "{0}/t"
          },
          "short": {
            "other": "{0} t"
          }
        },
        "inch": {
          "long": {
            "one": "{0} tomme",
            "other": "{0} tommer"
          },
          "narrow": {
            "other": "{0}″"
          },
          "perUnit": {
            "long": "{0} per tomme",
            "narrow": "{0}/in",
            "short": "{0}/tomme"
          },
          "short": {
            "one": "{0} tomme",
            "other": "{0} tommer"
          }
        },
        "kilobit": {
          "long": {
            "other": "{0} kilobit"
          },
          "narrow": {
            "other": "{0}kb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kb"
          }
        },
        "kilobyte": {
          "long": {
            "other": "{0} kilobyte"
          },
          "narrow": {
            "other": "{0}kB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kB"
          }
        },
        "kilogram": {
          "long": {
            "other": "{0} kilogram"
          },
          "narrow": {
            "other": "{0}kg"
          },
          "perUnit": {
            "long": "{0} per kilogram",
            "narrow": "{0}/kg",
            "short": "{0}/kg"
          },
          "short": {
            "other": "{0} kg"
          }
        },
        "kilometer": {
          "long": {
            "other": "{0} kilometer"
          },
          "narrow": {
            "other": "{0}km"
          },
          "perUnit": {
            "long": "{0} per kilometer",
            "narrow": "{0}/km",
            "short": "{0}/km"
          },
          "short": {
            "other": "{0} km"
          }
        },
        "kilometer-per-hour": {
          "long": {
            "other": "{0} kilometer per time"
          },
          "narrow": {
            "other": "{0}km/t"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} km/t"
          }
        },
        "liter": {
          "long": {
            "other": "{0} liter"
          },
          "narrow": {
            "other": "{0}l"
          },
          "perUnit": {
            "long": "{0} per liter",
            "narrow": "{0}/l",
            "short": "{0}/l"
          },
          "short": {
            "other": "{0} l"
          }
        },
        "liter-per-kilometer": {
          "long": {
            "other": "{0} liter per kilometer"
          },
          "narrow": {
            "other": "{0}l/km"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} l/km"
          }
        },
        "megabit": {
          "long": {
            "other": "{0} megabit"
          },
          "narrow": {
            "other": "{0}Mb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Mb"
          }
        },
        "megabyte": {
          "long": {
            "other": "{0} megabyte"
          },
          "narrow": {
            "other": "{0}MB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} MB"
          }
        },
        "meter": {
          "long": {
            "other": "{0} meter"
          },
          "narrow": {
            "other": "{0}m"
          },
          "perUnit": {
            "long": "{0} per meter",
            "narrow": "{0}/m",
            "short": "{0}/m"
          },
          "short": {
            "other": "{0} m"
          }
        },
        "meter-per-second": {
          "long": {
            "other": "{0} meter per sekund"
          },
          "narrow": {
            "other": "{0}m/s"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} m/s"
          }
        },
        "mile": {
          "long": {
            "one": "{0} mile",
            "other": "{0} miles"
          },
          "narrow": {
            "other": "{0}mi"
          },
          "perUnit": {
          },
          "short": {
            "one": "{0} mile",
            "other": "{0} miles"
          }
        },
        "mile-per-gallon": {
          "long": {
            "one": "{0} mile per gallon",
            "other": "{0} miles per gallon"
          },
          "narrow": {
            "other": "{0}mpg"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mpg"
          }
        },
        "mile-per-hour": {
          "long": {
            "one": "{0} engelsk mil per time",
            "other": "{0} engelske mil per time"
          },
          "narrow": {
            "other": "{0}mi/t"
          },
          "perUnit": {
          },
          "short": {
            "one": "{0} mile/t",
            "other": "{0} miles/t"
          }
        },
        "mile-scandinavian": {
          "long": {
            "other": "{0} mil"
          },
          "narrow": {
            "other": "{0}mil"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mil"
          }
        },
        "milliliter": {
          "long": {
            "other": "{0} milliliter"
          },
          "narrow": {
            "other": "{0}ml"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ml"
          }
        },
        "millimeter": {
          "long": {
            "other": "{0} millimeter"
          },
          "narrow": {
            "other": "{0}mm"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mm"
          }
        },
        "millisecond": {
          "long": {
            "one": "{0} millisekund",
            "other": "{0} millisekunder"
          },
          "narrow": {
            "other": "{0}ms"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ms"
          }
        },
        "minute": {
          "long": {
            "one": "{0} minutt",
            "other": "{0} minutter"
          },
          "narrow": {
            "other": "{0}m"
          },
          "perUnit": {
            "long": "{0} per minutt",
            "narrow": "{0}/min",
            "short": "{0}/min"
          },
          "short": {
            "other": "{0} min"
          }
        },
        "month": {
          "long": {
            "one": "{0} måned",
            "other": "{0} måneder"
          },
          "narrow": {
            "other": "{0} m"
          },
          "perUnit": {
            "long": "{0} per måned",
            "narrow": "{0}/m",
            "short": "{0}/md."
          },
          "short": {
            "other": "{0} md."
          }
        },
        "ounce": {
          "long": {
            "one": "{0} unse",
            "other": "{0} unser"
          },
          "narrow": {
            "other": "{0}oz"
          },
          "perUnit": {
            "long": "{0} per unse",
            "narrow": "{0}/unse",
            "short": "{0}/unse"
          },
          "short": {
            "one": "{0} unse",
            "other": "{0} unser"
          }
        },
        "percent": {
          "long": {
            "other": "{0} prosent"
          },
          "narrow": {
            "other": "{0}%"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} %"
          }
        },
        "petabyte": {
          "long": {
            "other": "{0} petabyte"
          },
          "narrow": {
            "other": "{0}PB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} PB"
          }
        },
        "pound": {
          "long": {
            "other": "{0} pund"
          },
          "narrow": {
            "other": "{0} pund"
          },
          "perUnit": {
            "long": "{0} per pund",
            "narrow": "{0}/pund",
            "short": "{0}/pund"
          },
          "short": {
            "other": "{0} pund"
          }
        },
        "second": {
          "long": {
            "one": "{0} sekund",
            "other": "{0} sekunder"
          },
          "narrow": {
            "other": "{0}s"
          },
          "perUnit": {
            "long": "{0} per sekund",
            "narrow": "{0}/s",
            "short": "{0}/s"
          },
          "short": {
            "other": "{0} sek"
          }
        },
        "stone": {
          "long": {
            "other": "{0} stone"
          },
          "narrow": {
            "other": "{0} st"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} st"
          }
        },
        "terabit": {
          "long": {
            "other": "{0} terabit"
          },
          "narrow": {
            "other": "{0}Tb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Tb"
          }
        },
        "terabyte": {
          "long": {
            "other": "{0} terabyte"
          },
          "narrow": {
            "other": "{0}TB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} TB"
          }
        },
        "week": {
          "long": {
            "one": "{0} uke",
            "other": "{0} uker"
          },
          "narrow": {
            "other": "{0}u"
          },
          "perUnit": {
            "long": "{0} per uke",
            "narrow": "{0}/u",
            "short": "{0}/u"
          },
          "short": {
            "other": "{0} u"
          }
        },
        "yard": {
          "long": {
            "other": "{0} yard"
          },
          "narrow": {
            "other": "{0}yd"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} yard"
          }
        },
        "year": {
          "long": {
            "other": "{0} år"
          },
          "narrow": {
            "other": "{0}å"
          },
          "perUnit": {
            "long": "{0} per år",
            "narrow": "{0}/år",
            "short": "{0}/år"
          },
          "short": {
            "other": "{0} år"
          }
        }
      }
    }
  },
  "locale": "nb"
})
}